import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleCreateList(
  list: Identifiable<List>,
  data: Boundaries["createList"]["success"],
): Identifiable<List> {
  const { list: newList } = data;
  const isTargetList =
    newList.parentList && list.uuid === newList.parentList.uuid;

  return isTargetList
    ? { ...list, subLists: [...list.subLists, newList] }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleCreateList(subList, data),
        ),
      };
}

export { handleCreateList };
